module.exports = __webpack_public_path__ + "img/92.fa1f41d2.jpg";